import React from 'react';
import styled from 'styled-components';

const OrSeparatorStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  // in case this is used under a parent that is not flex
  width: '100%',
});

const OrLine = styled.div({
  borderBottom: '1px solid grey',
  flex: '1',
});

const OrText = styled.div({
  marginLeft: '5px',
  marginRight: '5px',
  color: 'black',
});

const OrSeparator = () => (
  <OrSeparatorStyled>
    <OrLine />
    <OrText>Or</OrText>
    <OrLine />
  </OrSeparatorStyled>
);

export default OrSeparator;
